import script from "./LeftSidebarFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSidebarFavourites.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__